export default __webpack_public_path__ + "static/media/Avesh Resume.65e81080.pdf";